import "./RevenueManagementConsulting.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Benefits from "./sections/Benefits";
import Service from "./sections/Service";
import Footer from "@/reusable_sections/Footer";
export default function RevenueManagementConsultingPage() {
  return <div>
      <Header />
      <Hero />
      <Benefits />
      <Service />
      <Footer />
    </div>;
}